import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router'
import LoginForm from './loginForm';

class Login extends Component {

  onLogin = (values) => {
    const { accountLogin } = this.props;
    const { username, password } = values;
    accountLogin(username, password);
  }

  render() {
    const { isLoading, error, isLoggedIn } = this.props;
    if (isLoggedIn) {
      return <Redirect to={'/'}/>;
    }
    return(
      <div className='screen-login gradientColorBackground'>
        <div className='loginFormContainer containerWithBoxShadow'>
          <LoginForm onLogin={this.onLogin} isLoading={isLoading}/>
          { error && <p className='errorText'> {error} </p> }
        </div>
      </div>
    )
  }
}

Login.defaultProps = {
  isLoggedIn: false,
  isLoading: false,
  error: '',
};

Login.propTypes = {
  isLoggedIn: PropTypes.bool,
  isLoading: PropTypes.bool,
  error: PropTypes.string,

  accountLogin: PropTypes.func.isRequired,
};

export default Login;
